import { useMutation, UseMutationResult } from '@tanstack/react-query';
import { updateChargingServiceOperationHours } from '../../api/charging-service.ts';
import { UpdateChargingServiceOperationHoursRequest } from '../../api/requests/charging-service-request.ts';

export default function useUpdateChargingServiceOperationHours(): UseMutationResult<
  Awaited<ReturnType<typeof updateChargingServiceOperationHours>>,
  Error,
  UpdateChargingServiceOperationHoursRequest
> {
  return useMutation({
    mutationFn: updateChargingServiceOperationHours,
  });
}
